import type { InjectionKey } from 'vue';
import type { NormalizedPreconJobsGlobalOptions } from './options';

/**
 * The injection to get the options into the components.
 */
export const preconJobsOptionsInjectionKey = Symbol(
    'precon-jobs ui options'
) as InjectionKey<Readonly<NormalizedPreconJobsGlobalOptions>>;
